export const decryptPageProps = <T>(value: string): T => {
  return JSON.parse(value) as T;
};
